export const formatStationDisplayId = (unit) => {
  const source = typeof unit === 'string' || typeof unit === 'number'
    ? unit
    : unit?.deviceId || unit?.deviceNo || unit?.unitCode || unit?.stationId || '';
  const rawId = String(source).trim();
  if (!rawId) {
    return '-';
  }

  const digits = rawId.replace(/\D/g, '');
  if (digits.length >= 10) {
    return digits.slice(-10, -4);
  }

  if (digits.length >= 6) {
    return digits.slice(-6);
  }

  if (/^\d+$/.test(digits)) {
    return digits.padStart(6, '0').slice(-6);
  }

  return rawId.slice(-6);
};

export default formatStationDisplayId;
